import { Grid, GridColumnProps, GridProps, GridRowProps } from "semantic-ui-react";

export function BPGrid(props: GridProps) {
    return <Grid {...props}>{props.children}</Grid>;
}

export function BPGridRow(props: GridRowProps) {
    return <Grid.Row {...props}>{props.children}</Grid.Row>;
}

export function BPGridColumn(props: GridColumnProps) {
    return <Grid.Column {...props}>{props.children}</Grid.Column>;
}